"use client";

import { useRef } from "react";
import { useInView } from "motion/react";
import dynamic from "next/dynamic";

const BarChartInner = dynamic(
  () => import("./bar-chart-inner").then((m) => ({ default: m.BarChartInner })),
  { ssr: false },
);

export interface BarChartDataItem {
  label: string[];
  value: number;
  active?: boolean;
  hide_number?: boolean;
  hide_label?: boolean;
}

export interface BarChartProps {
  data: BarChartDataItem[];
  tickValues?: number[];
  graphHeight?: string | number;
  isDark?: boolean;
  isTile?: boolean;
  unit?: string;
}

export function BarChart(props: BarChartProps) {
  const ref = useRef<HTMLDivElement>(null);
  const isInView = useInView(ref, { once: true, margin: "200px 0px" });

  return (
    <div ref={ref} className="h-full w-full">
      {isInView ? <BarChartInner {...props} /> : null}
    </div>
  );
}
